import styled from 'styled-components';
import { AppList } from 'components/parts/appList';
import { WorkflowListButtonArea } from 'components/parts/workFlowListButtonArea';
import {
  Annotation,
  AnnotationVariant,
} from 'components/parts/common/annotation';
import { useEffect, useState } from 'react';
import { WORKFLOW_ANNOTATION } from 'constants/constants';

const TopLayout = styled.div`
  position: relative;
  height: calc(100% - 41px - 4vh);
  width: 100vw;
  box-sizing: border-box;
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  &::-webkit-scrollbar-corner {
    background: #25272a 0% 0% no-repeat padding-box;
    float: right;
  }
  &::-webkit-scrollbar-thumb {
    background: #676767;
    border-radius: 10px;
  }
`;

export const WorkflowList = () => {
  const [annotationVariant, setAnnotationVariant] =
    useState<AnnotationVariant>('');
  const [annotationMessage, setAnnotationMessage] = useState<string>('');
  const [expirationFlg, setExpirationFlg] = useState<boolean>(false);

  useEffect(() => {
    // アノテーションの表示判定処理
    if (expirationFlg) {
      setAnnotationMessage(
        WORKFLOW_ANNOTATION.LICENSE_BEFORE_EXPIRATION.MESSAGE,
      );
      setAnnotationVariant(
        WORKFLOW_ANNOTATION.LICENSE_BEFORE_EXPIRATION.VARIANT,
      );
    } else {
      setAnnotationMessage('');
      setAnnotationVariant('');
    }
  }, [expirationFlg]);

  return (
    <TopLayout>
      <Annotation message={annotationMessage} variant={annotationVariant} />
      <WorkflowListButtonArea />
      <AppList setExpirationFlg={setExpirationFlg} />
    </TopLayout>
  );
};
